<template>
  <div id="search" @keydown="e => handleKey(e)">
    <input ref="inputRef" type="text" placeholder="Search..." v-model="pattern">
    <div id="search-results" v-if="show" ref="hiddenInputRef">

      <div class="content">
        <div class="subheader" v-if="result.nodes.length > 0 ">Topics</div>
        <NodeListTile v-for="(node, index) in result.nodes" :node="node"
                      :search-mode="true"
                      :active="translatedIndex.node === index"
                      :id="`r${index}`"
                      @click="pattern = ''"
        />
        <div class="subheader" v-if="result.rct.length >0 ">RCT</div>
        <RctListTile v-for="(rct, index) in result.rct" :rct="rct"
                     :search-mode="true"
                     :key="index"
                     :active="translatedIndex.rct === index"
                     :id="`r${index + result.nodes.length}`"
                     @click="pattern = ''"
        />
        <div class="subheader" v-if="result.sr.length >0 ">SR</div>
        <SrListTile v-for="(sr, index) in result.sr" :sr="sr"
                    :active="translatedIndex.sr === index"
                    :search-mode="true"
                    :id="`r${index + result.nodes.length + result.rct.length}`"
                    @click="pattern = ''"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">

import {computed, defineComponent, inject, onMounted, ref, watchEffect} from "vue";
import NodeListTile from "@/components/NodeListTile.vue";
import RctListTile from "@/components/RctListTile.vue";
import SrListTile from "@/components/SrListTile.vue";
import {useMapStore} from "@/mixins/mapStore";
import {ISearchResult} from "@/interfaces/mapStore";

export default defineComponent({
  name: "Search",
  components: {RctListTile, NodeListTile, SrListTile},
  setup(props) {
    const pattern = ref("")
    const mapStore = useMapStore()
    const result = ref<ISearchResult>(mapStore.searchPattern(""))
    const activeIndex = ref(-1)
    const inputRef = ref<HTMLInputElement>(null)
    const translatedIndex = computed(() => {
      if (activeIndex.value == -1) {
        return {
          node: -1,
          rct: -1,
          sr: -1,
        }
      }
      return {
        node: result.value.nodes.length > activeIndex.value ? activeIndex.value : -1,
        rct: (result.value.nodes.length + result.value.rct.length) >
        activeIndex.value
            ? activeIndex.value - result.value.nodes.length
            : -1,
        sr: (result.value.nodes.length + result.value.rct.length + result.value.sr.length) >
        activeIndex.value
            ? activeIndex.value - result.value.nodes.length - result.value.rct.length
            : -1,
      }
    })
    const handleKey = (e: KeyboardEvent) => {

      if (e.code == "ArrowUp") {
        if(activeIndex.value > -1){
          activeIndex.value--
        }
      } else if (e.code == "ArrowDown") {
        if(activeIndex.value < (result.value.nodes.length + result.value.rct.length + result.value.sr.length -1 )) {
          activeIndex.value++
        }
      } else if (e.code == "Enter") {
        if (activeIndex.value != -1) {
          if (translatedIndex.value.node > -1) {
            mapStore.onNodeClick(result.value.nodes[translatedIndex.value.node])
          } else if (translatedIndex.value.rct > -1) {
            mapStore.onRctClick(result.value.rct[translatedIndex.value.rct])
          } else if (translatedIndex.value.sr > -1) {
            mapStore.onSrClick(result.value.sr[translatedIndex.value.sr])
          }
          pattern.value = ""
        }
      } else {
        activeIndex.value = -1
      }
      if (activeIndex.value == -1) {
        inputRef.value.focus()
      } else {
        // inputRef.value.blur()
        document.getElementById(`r${activeIndex.value}`).scrollIntoView();
      }
    }
    const show = computed(() => {
      if (result.value.sr.length > 0 || result.value.nodes.length > 0 || result.value.rct.length > 0) {
        if (document.getElementById("search").contains(document.activeElement)) {
          return true
        }

      }
      return false
    })
    watchEffect(() => result.value = mapStore.searchPattern(pattern.value))
    return {
      show,
      inputRef,
      pattern,
      result,
      handleKey,
      translatedIndex,
      activeIndex,
    }
  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

#search {
  input {
    width: 29.9vw;
    height: 4vh - 0.2vh;
    border: 0.1vh solid $primary;
    padding-left: $default-padding;
    line-height: 4vh;
    margin-right: 10px;

    &:focus {
      outline: none;
    }
  }

  #search-results {
    z-index: 2;
    position: absolute;
    height: 30vh;
    background-color: white;
    width: 31.1vw;
    display: flex;
    flex-direction: column;
    border: 0.05vw solid $primary;

    .content {
      height: 0;
      flex-grow: 1;
      overflow: scroll;

      .subheader {
        height: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-weight: bold;
        font-size: 1.4vh;
        color: white;
        background-color: $primary;
        padding-left: $default-padding;
      }
    }
  }
}
</style>